import React from "react";
import { SupportAnnounce4Component } from "./current/SupportAnnounce4Component";
import { SupportAnnounce5Component } from "./current/SupportAnnounce5Component";
import { SupportAnnounce11Component } from "./current/SupportAnnounce11Component";
import { useSearchParams } from "react-router-dom";

export function DetailSupportFormTestComponent() {

    const [searchParams] = useSearchParams();
    let supportTypeId = searchParams.get("type"); //type1 : ประกาศ 4, type2: ประกาศ 5 , type3 : ประกาศ 11
    console.log("supportTypeId", supportTypeId)
    return (
        <>
            {supportTypeId == "1" ? (<SupportAnnounce4Component />) : null}
            {supportTypeId == "2" ? (<SupportAnnounce5Component />) : null}
            {supportTypeId == "3" ? (<SupportAnnounce11Component />) : null}
        </>
    );
}
